import { api } from '@/config/api';

export interface CreditsBalance {
  balance: number; lifetimePurchased: number; period: string; includedMonthlyCredits: number; used: number; includedUsed: number; reserved: number; includedRemaining: number; grantedCredits: number; grantedAvailable: number; debtCredits: number; usedPercent: number; warningLevel: 'normal' | 'warning' | 'critical' | 'exhausted';
  byFeature: Array<{ _id: string; credits: number }>; byDay: Array<{ _id: string; credits: number }>;
}
export interface CreditLedgerEntry { entryUid: string; kind: string; credits: number; reason: string; createdAt: string; }

export interface CreditTier {
  amountUsd: number;
  credits: number;
  priceId: string;
}

export interface CreditTiersResponse {
  enabled: boolean;
  tiers: CreditTier[];
}

export interface CreditTopUpRow {
  topUpUid: string;
  stripeSessionId: string;
  amountCents: number;
  currency: string;
  credits: number;
  status: 'pending' | 'succeeded' | 'failed' | 'refunded';
  completedAt?: string;
  createdAt: string;
}

export const creditsService = {
  balance: async (): Promise<CreditsBalance> =>
    (await api.get('/slighter_crm/credits/balance')).data,

  ledger: async (page = 1): Promise<{ rows: CreditLedgerEntry[]; total: number; page: number; pageSize: number }> => (await api.get('/slighter_crm/credits/ledger', { params: { page } })).data,

  tiers: async (): Promise<CreditTiersResponse> =>
    (await api.get('/slighter_crm/credits/tiers')).data,

  history: async (limit = 20): Promise<CreditTopUpRow[]> =>
    (await api.get('/slighter_crm/credits/history', { params: { limit } })).data,

  checkout: async (priceId: string): Promise<{ url: string; sessionId: string }> =>
    (await api.post('/slighter_crm/credits/checkout', { priceId })).data,
};
